import React from "react";

export default ({ fill = "#646F81" }) => (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0.625 10.625L10.625 0.625" stroke={fill} stroke-width="1.25" />
        <circle cx="8.83845" cy="8.8393" r="1.78571" stroke={fill} stroke-width="1.25" />
        <circle cx="2.41071" cy="2.41071" r="1.78571" stroke={fill} stroke-width="1.25" />
    </svg>
);